/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Calm_Seal_DiveInputs */

const en_deep_calm_seal_dive = /** @type {(inputs: Deep_Calm_Seal_DiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restoring version...`)
};

const de_deep_calm_seal_dive = /** @type {(inputs: Deep_Calm_Seal_DiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version wird wiederhergestellt...`)
};

/**
* | output |
* | --- |
* | "Restoring version..." |
*
* @param {Deep_Calm_Seal_DiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_calm_seal_dive = /** @type {((inputs?: Deep_Calm_Seal_DiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Calm_Seal_DiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_calm_seal_dive(inputs)
	return de_deep_calm_seal_dive(inputs)
});